export enum MemberTypesEnum {
  PRINCIPAL = '0',
  SPOUSE = '1',
}
